module.exports = __webpack_public_path__ + "static/img/coming_soon.0077e98.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/coming_soon.jpeg
// module id = qHeD
// module chunks = 3